<template>
  <div>
    <div @click="save" class="buttonPrimary" :class="{'button--disable': !savable}">SAVE</div>
<!--    {{savable}}-->
  </div>
</template>

<script>
import API from "../../api/API";
import { DrawEvent } from "../../events/DrawEvent";
import * as types from "../../events/DrawEventType";
import * as StoreUtil from "../../util/StoreUtil";
import * as tabletTypes from "../../store/modules/tablet/types";
export default {
  name: "TabletSaveUI",
  computed: {
    savable() {
      return this.$store.state.canvas.savable;
    }
  },
  mounted() {
    DrawEvent.on(types.PUBLISH_DATA, this.onPublisData);
  },
  destroyed() {
    DrawEvent.off(types.PUBLISH_DATA, this.onPublishData);
  },
  methods: {
    save() {
      this.$store.dispatch(tabletTypes.namespace + tabletTypes.SET_MODAL, true);
    },
    onPublisData(data) {
      StoreUtil.showLoading();
      API.sendMessage(data.data, "", data.pos.x, data.pos.y)
        .then(
          () => {
            alert("描きこみました");
            this.$store.dispatch(
                    tabletTypes.namespace + tabletTypes.SET_MODAL,
                    false
            );
            //リロードできないので書き込みなし状態にしたい
            StoreUtil.setNeedReload(true);
            DrawEvent.emit(types.END_TABLET_DRAW);
          },
          e => {
            console.log("error", e);
          }
        )
        .finally(() => {
          StoreUtil.hideLoading();
        });
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"


</style>
